function Accordion(sections) {
    this.sections = sections;
    this.activeSection = '';

    for(let section of this.sections) {
        section.isOpen = false;
        section.accordionTriggers = findChildrenWithClass(section, "accordion__trigger");
        section.accordionContent = findChildrenWithClass(section, "accordion__content");
    }

    this.setupEvents();
}


Accordion.prototype.setupEvents = function () {
    for(let section of this.sections) {
        if(section.accordionTriggers.length && section.accordionContent.length) {
            for(let trigger of section.accordionTriggers) {
                // Set tabIndex to allow keyboard controls
                trigger.tabIndex = 0;

                trigger.addEventListener("click", e => {
                    this.handleEvent(section);
                });

                trigger.addEventListener("keydown", (e) => {
                    if(e.keyCode === 13) {
                        this.handleEvent(section);
                    }
                });
            }
        }
    }
};

Accordion.prototype.handleEvent = function(section) {
    section.isActive = !section.isActive;
    this.updateSection(section);

    if(section.isActive) {
        if(this.activeSection.id !== section.id) {
            if(this.activeSection) {
                this.activeSection.isActive = false;
                this.updateSection(this.activeSection);
                this.activeSection = "";
            }
            section.isActive = true;
            this.updateSection(section);
            this.activeSection = section;
        }
    } else {
        this.activeSection = "";
        this.updateSection(section);
    }
};

Accordion.prototype.updateSection = function(section) {
    if(section.isActive) {
        section.classList.add("open");
    } else {
        section.classList.remove("open");
    }

    for(let trigger of section.accordionTriggers) {
        trigger.setAttribute("aria-expanded", section.isActive);
    }

    for(let content of section.accordionContent) {
        content.setAttribute("aria-hidden", !section.isActive);
    }
};


/*
 * Returns an array of element's children that have a specific class
 */

function findChildrenWithClass(parent, className) {
    let children = [];

    for(let child of parent.children) {
        if(child.classList.contains(className)) {
            children.push(child);
        }
    }

    return children;
}


/*
 * ACCORDION COMPONENT INITIALIZATION
 * Valid HTML structure is as follows:
 * .accordion
 * 	.accordion__section
 *			.accordion__trigger
 *			.accordion__content
 */

(function() {
    let accordionComponents = document.querySelectorAll(".accordion");

    for(let accordion of accordionComponents) {
        let accordionSections = findChildrenWithClass(accordion, "accordion__section");
        accordionSections = accordionSections.filter(function(section) {
            if(!section.classList.contains("accordion__section--empty")) {
                return section;
            }
        });
        if(accordionSections.length) {
            new Accordion(accordionSections);
        }
    }
}());
